import { render, staticRenderFns } from "./allreceipt.vue?vue&type=template&id=6a0ee89b"
import script from "./allreceipt.vue?vue&type=script&lang=js"
export * from "./allreceipt.vue?vue&type=script&lang=js"
import style0 from "./allreceipt.vue?vue&type=style&index=0&id=6a0ee89b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports